var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F6EEF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.97 30.33C33.97 30.69 33.89 31.06 33.72 31.42C33.55 31.78 33.33 32.12 33.04 32.44C32.55 32.98 32.01 33.37 31.4 33.62C30.8 33.87 30.15 34 29.45 34C28.43 34 27.34 33.76 26.19 33.27C25.04 32.78 23.89 32.12 22.75 31.29C21.6 30.45 20.51 29.52 19.47 28.49C18.44 27.45 17.51 26.36 16.68 25.22C15.86 24.08 15.2 22.94 14.72 21.81C14.24 20.67 14 19.58 14 18.54C14 17.86 14.12 17.21 14.36 16.61C14.6 16 14.98 15.44 15.51 14.94C16.15 14.31 16.85 14 17.59 14C17.87 14 18.15 14.06 18.4 14.18C18.66 14.3 18.89 14.48 19.07 14.74L21.39 18.01C21.57 18.26 21.7 18.49 21.79 18.71C21.88 18.92 21.93 19.13 21.93 19.32C21.93 19.56 21.86 19.8 21.72 20.03C21.59 20.26 21.4 20.5 21.16 20.74L20.4 21.53C20.29 21.64 20.24 21.77 20.24 21.93C20.24 22.01 20.25 22.08 20.27 22.16C20.3 22.24 20.33 22.3 20.35 22.36C20.53 22.69 20.84 23.12 21.28 23.64C21.73 24.16 22.21 24.69 22.73 25.22C23.27 25.75 23.79 26.24 24.32 26.69C24.84 27.13 25.27 27.43 25.61 27.61C25.66 27.63 25.72 27.66 25.79 27.69C25.87 27.72 25.95 27.73 26.04 27.73C26.21 27.73 26.34 27.67 26.45 27.56L27.21 26.81C27.46 26.56 27.7 26.37 27.93 26.25C28.16 26.11 28.39 26.04 28.64 26.04C28.83 26.04 29.03 26.08 29.25 26.17C29.47 26.26 29.7 26.39 29.95 26.56L33.26 28.91C33.52 29.09 33.7 29.3 33.81 29.55C33.91 29.8 33.97 30.05 33.97 30.33Z",
    stroke: "#550080",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/callIcon.51a89691e009e2c963ce19c2ac9d956c.svg";
export { ForwardRef as ReactComponent };